if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      this.cartNotification.setActiveElement(document.activeElement);

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      formData.append('sections', this.cartNotification.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          this.form.querySelector('button.product-form__submit').classList.add('hide-this');
          this.querySelector('limiter-alert').style.display = 'block';
          this.cartNotification.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

if (!customElements.get('limiter-alert')) {
  class limiterAlert extends HTMLElement {
    constructor() {
      super();
      this.add = this.querySelector('.product-form__submit');
      this.cancel = this.querySelector('.action__cancel');
      this.proceed = this.querySelector('.action__continue');
      this.form = this.closest('form');
      this.submitBtn = this.closest('form').querySelector('button.product-form__submit');
      this.dismissed = false;
      this.continued = false;

      if(this.form.querySelector('[name="product_type"]').value === 'Custom Order') {
        this.isCustom = true;
      } else {
        this.isCustom = false;
      }

      // events
      this.cancel.addEventListener('click', this.closeModal.bind(this));
      this.add.addEventListener('click', this.checkProducts.bind(this));
      this.proceed.addEventListener('click', this.continue.bind(this));
    }

    closeModal() {
      this.removeAttribute('open');
      this.dismissed = true;
    }

    continue() {
      let _that = this;
      let submitBtn = this.submitBtn;
      fetch(`/cart/clear.js`)
      .then((response) => response.json())
      .then((response) => {
        document.querySelector('.cart-count-bubble span').innerText = '0';
        _that.removeAttribute('open');
        _that.continued = true;
        _that.style.display = 'none';
        submitBtn.classList.remove('hide-this');
        submitBtn.removeAttribute('disabled');
        submitBtn.click();
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {});
    }

    checkProducts() {
      let _that = this;
      let submitBtn = this.submitBtn;
      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      if(!this.continued) {
        fetch(`${routes.cart_url}.js`, config)
        .then((response) => response.json())
        .then((response) => {
          if(response.items.length > 0) {
            let customInCart = false;
            let normalProductsInCart = false;
            response.items.forEach(item => {
              if(item.product_type == "Custom Order"){
                customInCart = true;
              } else {
                normalProductsInCart = true;
              }
            });

            if(this.isCustom && normalProductsInCart) {
              _that.setAttribute('open', '');
            } else if (!this.isCustom && customInCart){
              _that.setAttribute('open', '');
            } else {
              _that.style.display = 'none';
              submitBtn.classList.remove('hide-this');
              submitBtn.removeAttribute('disabled');
              submitBtn.click();
            }
          } else {
            _that.style.display = 'none';
            submitBtn.classList.remove('hide-this');
            submitBtn.removeAttribute('disabled');
            submitBtn.click();
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
        });
      } else {
        _that.style.display = 'none';
        submitBtn.classList.remove('hide-this');
        submitBtn.removeAttribute('disabled');
        this.submitBtn.click();
      }
    }
  }

  customElements.define('limiter-alert', limiterAlert);
}

// Handle sticky ATC button on mobile
window.addEventListener('DOMContentLoaded',function () {
  if(window.innerWidth <=480 ) {
    var cartButton = document.querySelector('.sticky-button-container_ccz');
    var bounding = cartButton.getBoundingClientRect();

    if (bounding.top >= 0 && bounding.left >= 0 && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
      cartButton.classList.remove('sticky');
    }
    else {
      cartButton.classList.add('sticky');
    }
  }
});

window.addEventListener('scroll',function () {
  if(window.innerWidth <=480 ) {
    var cartButton = document.querySelector('.limiter_alert_cart');
    var bounding = cartButton.getBoundingClientRect();

    if (bounding.top >= 0 && bounding.left >= 0 && bounding.right <= (window.innerWidth || document.documentElement.clientWidth) && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)) {
      document.querySelector('.sticky-button-container_ccz').classList.remove('sticky');
    }
    else {
      document.querySelector('.sticky-button-container_ccz').classList.add('sticky');
    }
  }
});

// Handle sticky variant select functionality
window.addEventListener('DOMContentLoaded', function() {
  const stickyVariantSelect = document.querySelector('.sticky-product-variant-options-select');
  const mainVariantSelects = document.querySelectorAll('variant-selects select, variant-radios input[type="radio"]');
  const stickyPriceElement = document.querySelector('.sticky-product-price-text');
  const stickyAddToCartButton = document.querySelector('#add-to-cart-button');
  const stickyAddToCartText = document.querySelector('#add-to-cart-text');
  const mainProductForm = document.querySelector('product-form');
  
  if (!stickyVariantSelect) return;

  // Get product data
  const productDataScript = document.querySelector('#product-data');
  let productVariants = [];
  if (productDataScript) {
    try {
      productVariants = JSON.parse(productDataScript.textContent);
    } catch (error) {
      console.error('Error parsing product data:', error);
    }
  }
  
  if (productVariants.length === 0) {
    console.warn('No product variants found');
    return;
  }

  // Function to update sticky elements based on selected variant
  function updateStickyElements(variantId) {
    const variant = productVariants.find(v => v.id.toString() === variantId.toString());
    if (!variant) {
      console.warn('Variant not found:', variantId);
      return;
    }

    // Update price
    if (stickyPriceElement) {
      // Try to use Shopify's money format if available
      if (window.Shopify && window.Shopify.formatMoney) {
        stickyPriceElement.textContent = window.Shopify.formatMoney(variant.price);
      } else {
        // Fallback to basic currency formatting
        const price = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: window.Shopify?.currency?.active || 'USD'
        }).format(variant.price / 100);
        stickyPriceElement.textContent = price;
      }
    }

    // Update add to cart button state
    if (stickyAddToCartButton && stickyAddToCartText) {
      if (variant.available) {
        stickyAddToCartButton.removeAttribute('disabled');
        stickyAddToCartText.textContent = window.variantStrings?.addToCart || 'Add to cart';
      } else {
        stickyAddToCartButton.setAttribute('disabled', 'disabled');
        stickyAddToCartText.textContent = window.variantStrings?.soldOut || 'Sold out';
      }
    }

    // Update main form variant input
    const mainVariantInput = mainProductForm?.querySelector('input[name="id"]');
    if (mainVariantInput) {
      mainVariantInput.value = variantId;
      mainVariantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // Handle sticky variant select change
  stickyVariantSelect.addEventListener('change', function(e) {
    const selectedVariantId = e.target.value;
    updateStickyElements(selectedVariantId);
  });

  // Sync with main variant selects
  mainVariantSelects.forEach(select => {
    select.addEventListener('change', function() {
      // Find the currently selected variant from main form
      const mainVariantInput = mainProductForm?.querySelector('input[name="id"]');
      if (mainVariantInput && mainVariantInput.value) {
        stickyVariantSelect.value = mainVariantInput.value;
        updateStickyElements(mainVariantInput.value);
      }
    });
  });

  // Listen for variant changes from the main variant selector components
  const variantRadios = document.querySelector('variant-radios');
  const variantSelects = document.querySelector('variant-selects');
  
  if (variantRadios) {
    variantRadios.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        stickyVariantSelect.value = e.detail.variant.id;
        updateStickyElements(e.detail.variant.id);
      }
    });
  }
  
  if (variantSelects) {
    variantSelects.addEventListener('variant:change', function(e) {
      if (e.detail && e.detail.variant) {
        stickyVariantSelect.value = e.detail.variant.id;
        updateStickyElements(e.detail.variant.id);
      }
    });
  }

  // Initialize sticky elements with current variant
  const currentVariantId = stickyVariantSelect.value;
  if (currentVariantId) {
    updateStickyElements(currentVariantId);
  }

  // Watch for changes in the main variant input
  const mainVariantInput = mainProductForm?.querySelector('input[name="id"]');
  if (mainVariantInput) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
          const newVariantId = mainVariantInput.value;
          if (newVariantId && newVariantId !== stickyVariantSelect.value) {
            stickyVariantSelect.value = newVariantId;
            updateStickyElements(newVariantId);
          }
        }
      });
    });
    
    observer.observe(mainVariantInput, {
      attributes: true,
      attributeFilter: ['value']
    });
  }

  // Handle sticky add to cart button click
  if (stickyAddToCartButton) {
    stickyAddToCartButton.addEventListener('click', function(e) {
      e.preventDefault();
      
      // Trigger the main product form submission
      const mainSubmitButton = mainProductForm?.querySelector('button[type="submit"]');
      if (mainSubmitButton && !mainSubmitButton.hasAttribute('disabled')) {
        mainSubmitButton.click();
      }
    });
  }
});